import { fontGroups } from '@zoopla-eng/zds/themes';
import { VisuallyHidden } from '@zoopla/shared/components';
import { styledIndicatorStyle } from './UpdateIndicator.styles.css';

interface Props {
    count?: string;
    type?: 'large' | 'navVariant';
}

export const UpdateIndicator = ({ count, type }: Props) => {
    return (
        <span
            data-testid="header-notifications-new"
            className={`${styledIndicatorStyle({ type })}`}
        >
            {count ? (
                <span className={fontGroups.spoon} aria-hidden>
                    {count}
                </span>
            ) : null}
            <VisuallyHidden>You have {count} new updates</VisuallyHidden>
        </span>
    );
};
